import { useEffect, useState } from "react";
import { toast } from "react-toastify";

import { insertOrUpdateIPSettings, deleteIPSettings } from "../../services/ipSettings_service";

export const InsertOrUpdateIpSettingsModal = ({
  show,
  mode,
  type,
  initialData,
  onClose,
  dataReload
}) => {

  const [form, setForm] = useState({
    ipAddress: "",
    comments: ""
  });

  useEffect(() => {

    if (initialData) {

      setForm({
        ipAddress: initialData.ipAddress || "",
        comments: initialData.comments || ""
      });

    }

  }, [initialData]);

  if (!show) return null;

  const handleChange = (e) => {

    setForm({
      ...form,
      [e.target.name]: e.target.value
    });

  };

  const handleSave = async () => {

    try {

      const payload = {
        ...initialData,
        ...form
      };

      await insertOrUpdateIPSettings(payload);

      toast.success("IP setting saved successfully.");

      dataReload();
      onClose();

    }
    catch {
      toast.error("Unable to save IP setting");
    }

  };

  const modalTitle =
    mode === "add"
      ? `Add New ${type === "black" ? "Black List" : "White List"}`
      : `Edit ${type === "black" ? "Black List" : "White List"}`;

  return (
    <>

      <div className="modal fade in" style={{ display: "block" }}>

        <div className="modal-dialog" style={{ width: "650px" }}>

          <div className="modal-content">

            {/* HEADER */}

            <div className="modal-header" style={{ padding: "0px 0px" }}>

              <button
                type="button"
                className="close"
                onClick={onClose}
              >
                &times;
              </button>

              <h4 className="modal-title" style={{ margin: 0 }}>
                {modalTitle}
              </h4>

            </div>

            {/* BODY */}

            <div
              className="modal-body"
              style={{ paddingBottom: "85px", paddingTop: "30px" }}
            >

              <div className="form-group">

                <label className="col-sm-4">
                  IP Address :
                </label>

                <div className="col-sm-8">

                  <input
                    type="text"
                    name="ipAddress"
                    className="form-control"
                    value={form.ipAddress}
                    onChange={handleChange}
                  />

                </div>

                <div className="clearfix"></div>
                <br />

                <label className="col-sm-4">
                  Description :
                </label>

                <div className="col-sm-8">

                  <input
                    type="text"
                    name="comments"
                    className="form-control"
                    value={form.comments}
                    onChange={handleChange}
                  />

                </div>

              </div>

            </div>

            {/* FOOTER */}

            <div className="modal-footer">

              <button
                className="btn btn-primary"
                onClick={handleSave}
              >
                {mode === "add" ? "Add" : "Update"}
              </button>

              <button
                className="btn btn-default"
                onClick={onClose}
              >
                Cancel
              </button>

            </div>

          </div>

        </div>

      </div>

    </>
  );
};

export const DeleteIpSettingsModal = ({
  show,
  type,
  rowData,
  onClose,
  dataReload
}) => {

  if (!show) return null;

  const listType = type === "black" ? "black" : "white";

  const handleConfirmDelete = async (row) => {

  try {

    await deleteIPSettings({
      ...row,
      isActive: false
    });

    toast.success("IP deleted successfully.");

    dataReload();
    onClose();

  }
  catch {
    toast.error("Unable to delete IP.");
  }

};

  return (
    <>
      <div className="modal fade in" style={{ display: "block" }}>

        <div className="modal-dialog" style={{ width: "650px" }}>

          <div className="modal-content">

            {/* HEADER */}

            <div className="modal-header" style={{ padding: "0px 0px" }}>

              <button
                type="button"
                className="close"
                onClick={onClose}
              >
                &times;
              </button>

              <h4 className="modal-title" style={{ margin: 0 }}>
                Delete {listType === "black" ? "Black List" : "White List"} IP
              </h4>

            </div>

            {/* BODY */}

            <div
              className="modal-body"
              style={{
                paddingBottom: "40px",
                paddingTop: "30px"
              }}
            >

              <p>
                Do you want to delete this IP from the{" "}
                <strong>{listType}</strong> list?
              </p>

              <br />

              <div className="form-group">

                <label className="col-sm-4">
                  IP Address :
                </label>

                <div className="col-sm-8" style={{ paddingTop: "7px" }}>
                  {rowData?.ipAddress}
                </div>

                <div className="clearfix"></div>
                <br />

                <label className="col-sm-4">
                  Description :
                </label>

                <div className="col-sm-8" style={{ paddingTop: "7px" }}>
                  {rowData?.comments || "-"}
                </div>

              </div>

            </div>

            {/* FOOTER */}

            <div className="modal-footer">

              <button
                className="btn btn-primary"
                onClick={() => handleConfirmDelete(rowData)}
              >
                Delete
              </button>

              <button
                className="btn btn-default"
                onClick={onClose}
              >
                Cancel
              </button>

            </div>

          </div>

        </div>

      </div>
    </>
  );
};